import IPropertyError from "../models/PropertyError/IPropertyError";

export default abstract class BaseViewModel {
  protected _errors: Array<IPropertyError> = [];
  abstract CompileErrors(): void;
}
